import { gtmEvent } from 'lib/gtm'

// Reported to Amplitude as a form_submit event (Category/Action), the same
// path the accept-leads toggle uses. The marketplace helper conversion table
// filters on these exact values.
export const trackCoachProfileVisibilityChanged = enabled => {
  gtmEvent({
    event: 'formSubmit',
    formCategory: 'profile-visibility',
    formAction: enabled
      ? 'enable-profile-visibility'
      : 'disable-profile-visibility',
  })
}
